export function formatHTMLString(html: string): string {
    if (!html) return '';
    return html.replace("&lt;", "<").replace("&gt;", ">")
}